export const LOAD_COMPONENT = "LOAD_COMPONENT";
